import React from 'react';
import {Trans} from '@lingui/macro';
import { ExclamationCircleFilled } from '@ant-design/icons';

export const GenericWarningModalInfo = {
    title: () => (
        <>
            <ExclamationCircleFilled
                style={{ color: '#faad14', marginRight: 3, fontSize: 22, position: 'relative', top: 3 }}
            />
            &nbsp;&nbsp;
            <Trans>Warning</Trans>
        </>
    ),
    onOk: (_, handleOk, action) => {
        const newAction = {...action};
        newAction.request.intercept_feedback = true;
        handleOk(newAction);
    },
    bodyStyle: { marginInlineStart: '34px' },
    noPasscode: true,
    okText: 'Save',
};

function GenericWarningModal(props) {
    const { message } = props;
    return (
        <span>
            <p>
                {message}
            </p>
            <p>
                <Trans>Do you want to proceed?</Trans>
            </p>
        </span>
    );
}

export default GenericWarningModal;
